(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2926],{

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 73512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/signature",
      function () {
        return __webpack_require__(24094);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fB": function() { return /* binding */ BuilderShowCaseSection; },
/* harmony export */   "uV": function() { return /* binding */ ShowCaseCard; }
/* harmony export */ });
/* unused harmony export showcaseData */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const showcaseData = [
    {
        id: 1,
        navText: "Persona"
    },
    {
        id: 2,
        navText: "Knowledge"
    },
    {
        id: 3,
        navText: "ActionBooks"
    },
    {
        id: 4,
        navText: "Boundaries"
    }
];
function ShowCase(param) {
    let { scrollToCard , activeIndex , setActiveIndex , categories , isDarkMode  } = param;
    const handleClick = (idx)=>{
        setActiveIndex(idx);
        scrollToCard === null || scrollToCard === void 0 ? void 0 : scrollToCard(idx); // Call scroll function
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "md:flex-row md:flex hidden flex-col justify-center items-center w-full gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex-1 md:w-auto w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col ",
                    children: categories === null || categories === void 0 ? void 0 : categories.map((item, idx)=>{
                        const isActive = activeIndex === idx;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            className: "relative h-[46px] bg-transparent ".concat(isActive ? "" : "border-t", " ").concat(isDarkMode ? "text-gray-300" : "text-gray-600", "  flex justify-start items-center gap-2 hover:bg-black/ ").concat(isActive ? "border-gray-900 font-bold" : "border-gray-300"),
                            onClick: ()=>handleClick(idx),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "rounded-full border font-medium ".concat(isDarkMode ? "border-white" : "border-black", "  flex justify-center items-center w-7 h-7  ").concat(isActive ? "".concat(isDarkMode ? "bg-white text-black" : "bg-black text-white") : "".concat(isDarkMode ? "text-gray-300" : "text-black bg-transparents")),
                                    children: idx + 1
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "relative z-10 text-lg whitespace-nowrap",
                                    children: item
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    // background: linear-gradient(275deg, #c86aff -8.37%, #3164ff)
                                    // want to use linear -gradient as bg color
                                    className: "absolute top-0 left-0 h-[3px] bg-gradient-to-r from-[#c86aff] to-[#3164ff] transition-all ease-linear duration-300",
                                    style: {
                                        width: isActive ? "100%" : "0%"
                                    }
                                })
                            ]
                        }, item.id);
                    })
                })
            })
        })
    });
}
function ShowCaseCard(param) {
    let { title , desc , imgSrc , titleSize ="4xl" , descSize ="xl" , gap =0 , mb =0 , idx =0 , cat  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-4 md:gap-8 pb-12 md:pb-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:flex-row gap-3 md:gap-8 mb-8 ".concat(cat ? "border-t border-gray-300 pt-4" : "", " md:border-0 md:pt-0"),
                children: [
                    cat && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-2 md:hidden ",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                // isActive ? "bg-black text-white" : "text-black bg-transparents"
                                className: "rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white inline",
                                children: idx + 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "relative z-10 text-lg inline font-medium",
                                children: cat
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "flex-1 text-2xl md:text-".concat(titleSize, " font-semibold"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "flex-1 text-".concat(descSize, " "),
                        children: desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: imgSrc,
                alt: "ai-agent-builder",
                width: 1280,
                height: 490,
                className: "w-full object-cover h-full rounded-xl md:rounded-[30px]"
            })
        ]
    });
}
const BuilderShowCaseSection = (param)=>{
    let { heading ="" , categories =[] , showcaseData =[] , isDarkMode =false  } = param;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const cardRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const scrollingRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // const scrollToCard = (index) => {
    //   cardRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
    //   setActiveIndex(index);
    // };
    // Scroll to card when activeIndex changes
    const scrollToCard = (index)=>{
        var _cardRefs_current_index;
        scrollingRef.current = true;
        (_cardRefs_current_index = cardRefs.current[index]) === null || _cardRefs_current_index === void 0 ? void 0 : _cardRefs_current_index.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
        // Reset scrolling flag after animation completes
        setTimeout(()=>{
            scrollingRef.current = false;
        }, 1000);
    };
    // Set up Intersection Observer to detect which card is in view
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const observerOptions = {
            root: null,
            rootMargin: "0px 0px -50% 0px",
            threshold: 0.1
        };
        const observerCallback = (entries)=>{
            // Ignore during programmatic scrolling
            if (scrollingRef.current) return;
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const index = cardRefs.current.findIndex((ref)=>ref === entry.target);
                    if (index !== -1) {
                        setActiveIndex(index);
                    }
                }
            });
        };
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        // Observe all cards
        cardRefs.current.forEach((card)=>{
            if (card) observer.observe(card);
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto py-10 ".concat(isDarkMode ? "text-white" : "text-gray-900"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-4xl md:text-5xl font-semibold mb-16 md:mb-24 md:pl-72",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-2 w-[24%] pr-12 hidden md:block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full sticky top-[113px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCase, {
                                    scrollToCard: scrollToCard,
                                    activeIndex: activeIndex,
                                    setActiveIndex: setActiveIndex,
                                    categories: categories,
                                    isDarkMode: isDarkMode
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex-1 ",
                            children: showcaseData.map((data, idx)=>{
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: (el)=>cardRefs.current[idx] = el,
                                    className: "scroll-mt-[130px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowCaseCard, {
                                        title: data.heading,
                                        desc: data.subHeading,
                                        imgSrc: data.imgSrc,
                                        idx: idx,
                                        cat: categories === null || categories === void 0 ? void 0 : categories[idx]
                                    })
                                }, idx);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 59183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71605);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46687);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2208);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var _components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71631);
/* harmony import */ var react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69274);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56475);









const CtaOne = (param)=>{
    let { heading1 , heading2 , heading3 , paragraph , paragraphStyling , buttonsStyling , buttonPrimaryText , buttonPrimaryUrl , buttonPrimaryIcon , buttonPrimaryBorderShadow , buttonPrimaryNewTab , buttonPrimaryBg , buttonSecondaryText , buttonSecondaryUrl , buttonSecondaryIcon , buttonSecondaryNewTab , signaturePopupOpen  } = param;
    var _context_globalData, _context_globalData_utmData;
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        open: false,
        mode: "register"
    });
    const [is1DollarTrialCampaignState, setIs1DollarTrialCampaignState] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const isSignaturePage = signaturePopupOpen;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        var _context_globalData, _context_globalData_utmData;
        setIs1DollarTrialCampaignState((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .is1DollarTrialCampaign */ .Og)({
            utm_campaign: context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
        }));
    }, [
        context === null || context === void 0 ? void 0 : (_context_globalData = context.globalData) === null || _context_globalData === void 0 ? void 0 : (_context_globalData_utmData = _context_globalData.utmData) === null || _context_globalData_utmData === void 0 ? void 0 : _context_globalData_utmData.utm_campaign
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col gap-7 sm:gap-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SignatureRegister__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isPopupOpen: signaturePopup.open && isSignaturePage,
                mode: signaturePopup.mode,
                setIsPopupOpen: (value)=>setSignaturePopup((prev)=>({
                            ...prev,
                            open: value
                        })),
                setMode: (mode)=>setSignaturePopup((prev)=>({
                            ...prev,
                            mode: mode
                        }))
            }),
            heading1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "font-bold text-4xl sm:text-5xl lg:text-6xl mxl:text-7xl",
                children: heading1
            }),
            heading2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold leading-[45px] sm:leading-[55px] lg:leading-tight text-[36px] sm:text-[48px] lg:text-5xl",
                children: heading2
            }),
            heading3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "font-bold text-2xl sm:text-3xl",
                children: heading3
            }),
            paragraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg sm:text-xl ".concat(paragraphStyling),
                children: paragraph
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-2 flex items-center flex-wrap gap-4 sm:gap-6 ".concat(buttonsStyling && buttonsStyling),
                children: [
                    buttonPrimaryText && (isSignaturePage ? is1DollarTrialCampaignState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_google_ads_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .Button1 */ .g, {
                        btnText: buttonPrimaryText,
                        bgColor: buttonPrimaryBg || "bg-violet-500",
                        textColor: "text-white",
                        border: "border border-violet-500 ",
                        showLoading: false,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {}),
                        borderShadow: buttonPrimaryBorderShadow !== null && buttonPrimaryBorderShadow !== void 0 ? buttonPrimaryBorderShadow : true,
                        px: "px-5"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .ButtonPrimaryDiv */ .gf, {
                        buttonText: buttonPrimaryText,
                        onclick: ()=>setSignaturePopup((prev)=>({
                                    ...prev,
                                    open: true
                                })),
                        buttonUrl: buttonPrimaryUrl,
                        icon: buttonPrimaryIcon,
                        borderShadow: buttonPrimaryBorderShadow,
                        newTab: buttonPrimaryNewTab,
                        bgColor: buttonPrimaryBg
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonPrimary */ .IS, {
                        buttonText: buttonPrimaryText,
                        buttonUrl: buttonPrimaryUrl,
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_hi2__WEBPACK_IMPORTED_MODULE_8__/* .HiArrowLongRight */ .P8b, {})
                    })),
                    buttonSecondaryText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_7__/* .CLMButtonSecondaryBorder */ .AL, {
                        buttonText: buttonSecondaryText,
                        buttonUrl: buttonSecondaryUrl
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CtaOne);


/***/ }),

/***/ 24094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signature; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/v2/Legality/index.jsx
var Legality = __webpack_require__(95499);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
// EXTERNAL MODULE: ./components/CLM/BuilderShowCase/index.jsx
var BuilderShowCase = __webpack_require__(71575);
// EXTERNAL MODULE: ./components/CLM/CLMHero2/index.jsx
var CLMHero2 = __webpack_require__(29937);
// EXTERNAL MODULE: ./components/CLM/v3/Buttons.jsx
var Buttons = __webpack_require__(56475);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/createLucideIcon.js + 3 modules
var createLucideIcon = __webpack_require__(91373);
;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/recycle.js
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
];
const Recycle = (0,createLucideIcon/* default */.Z)("recycle", __iconNode);


//# sourceMappingURL=recycle.js.map

;// CONCATENATED MODULE: ./node_modules/lucide-react/dist/esm/icons/rocket.js
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const rocket_iconNode = [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
];
const Rocket = (0,createLucideIcon/* default */.Z)("rocket", rocket_iconNode);


//# sourceMappingURL=rocket.js.map

// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/check.js
var icons_check = __webpack_require__(13742);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./components/v2/MiniComponents/index.jsx
var MiniComponents = __webpack_require__(61325);
// EXTERNAL MODULE: ./constants/certifications.js
var certifications = __webpack_require__(1627);
;// CONCATENATED MODULE: ./pages/clm/signature/index.jsx















const CLMHeroData = {
    // title: "Reporting",
    heading: "Integrated eSignatures built for contract precision",
    description: "From drafting to signing—keep every step secure, compliant, and within one unified platform.",
    image: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/signature-hero.gif"),
    // logo: `${BASE_ASSETS_URL}/v2/clm/clm/ai-assistant-logo.png"),
    btnText: "Request a Demo",
    btnUrl: "/clm/request-demo"
};
const signatureReportingData = [
    {
        icon: Recycle,
        text: "Save time by automating routine tasks for scaling your small business."
    },
    {
        icon: Rocket,
        text: "Speed up your business contracts for quicker decisions and better agility."
    },
    {
        icon: index_esm/* MdOutlinePeopleAlt */.Zs9,
        text: "Facilitate better teamwork with features designed for easy collaboration."
    }
];
const showcaseData = [
    {
        heading: "Upload your business contracts and get it signed in a few clicks",
        subHeading: "Get your PDFs signed in a secure and professional way to manage agreements with clients, suppliers, and employees.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-upload-1.png")
    },
    {
        heading: "Customize PDF templates and reuse them anytime to meet your business needs",
        subHeading: "Assign roles and reuse the pre-made templates that you created to save time and avoid repetitive tasks.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-customize-1.png")
    },
    {
        heading: "Collect important data and get signatures on forms that ensure compliance",
        subHeading: "Easily generate forms like registrations and purchase orders — all with secure, legally binding signatures.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-collect-1.png")
    }
];
const showcaseData2 = [
    {
        heading: "Automate contracts with reusable templates",
        subHeading: "Convert any document into a smart template. Let your team auto-fill details like names and dates to create accurate contracts in just a few clicks.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-automate.png")
    },
    {
        heading: "Simplify online terms management with BoloSign",
        subHeading: "Let your legal team edit, organize, and publish your website’s terms and policies in one secure, easy-to-use workspace.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-simplify.png")
    },
    {
        heading: "Close contracts faster with BoloSign integrations",
        subHeading: "Connect your existing tools to create, track, and sign contracts with AI-powered speed and precision.",
        imgSrc: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-close.png")
    }
];
const Signature = (param)=>{
    let { isDarkMode , setIsDarkMode  } = param;
    const categories = [
        "PDFs",
        "PDFs Templates",
        "Forms"
    ];
    const cardRefs = (0,react.useRef)([]);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const sectionRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        const section = sectionRef.current;
        if (!section) return;
        const handleScroll = ()=>{
            const rect = section.getBoundingClientRect();
            const topTrigger = 120; // or some margin like 100
            const bottomTrigger = window.innerHeight;
            const isInView = rect.top <= topTrigger && rect.bottom >= bottomTrigger / 2;
            setIsDarkMode(isInView);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll(); // Initial check
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    const scrollToCard = (index)=>{
        if (cardRefs.current[index]) {
            cardRefs.current[index].scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
            setActiveIndex(index);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "eSignatures - BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Secure, legally binding eSignatures built for contracts—only with BoloSign CLM."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign eSignature, digital signatures, electronic signatures, contract signing, secure eSignatures, legally binding signatures, contract lifecycle management, CLM eSignatures"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/signature/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CLMHero2/* default */.Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "bg-dark text-white py-12 px-6 md:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-4xl md:text-5xl mb-14 text-center",
                        children: "Affordable eSignature solution for your team"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-screen-xl xl:px-8 mx-auto flex flex-col md:flex-row gap-6 justify-between items-center",
                        children: signatureReportingData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-start flex flex-col items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                        className: "text-white",
                                        size: 48
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#2A2A2A] p-10 px-12 rounded-xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-2xl",
                                            children: item.text
                                        })
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "px-0 md:px-8 bg-cream",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " max-w-screen-xl mx-auto px-6 xl:px-8 md:py-32 py-16 text-black md:rounded-2xl flex flex-col md:flex-row gap-6 md:gap-12 justify-between ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Legality/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "transition-colors duration-300  ".concat(isDarkMode ? "bg-dark text-white" : "bg-white text-black"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    ref: sectionRef,
                    className: "pt-40",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderShowCase/* BuilderShowCaseSection */.fB, {
                        heading: "Why BoloSign is the best solution for your business",
                        // Implementation, Audit Trial, Version Control, Legal
                        categories: [
                            "PDFs",
                            "PDFs Templates",
                            "Forms"
                        ],
                        showcaseData: showcaseData,
                        isDarkMode: isDarkMode
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "text-black px-6 md:px-8 mb-10 md:mb-28 mt-10 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-2xl md:text-5xl pb-4 md:pb-8 max-w-screen-lg mx-auto text-center font-bold mb-4 xl:mb-8 md:mt-12",
                        children: "Manage contracts, collect e-signatures & track progress—All in one platform"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-screen-xl xl:px-8 mx-auto flex flex-col md:flex-row gap-6 justify-between items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-review.png"),
                                        alt: "filter-by",
                                        width: 300,
                                        height: 300,
                                        className: "w-full h-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xl md:text-2xl font-semibold mb-2",
                                                children: "Customizable emails"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg md:text-xl",
                                                children: "Edit the emails you send with signature requests to match your business’ tone and style, making every interaction professional."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-signing-order.png"),
                                        alt: "expiry-is",
                                        width: 300,
                                        height: 300,
                                        className: "w-full h-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xl md:text-2xl font-semibold mb-2",
                                                children: "Multi-recipient signature requests"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg md:text-xl",
                                                children: "Send signature requests to multiple individuals, allowing collaboration and simultaneous signing on a single document."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center flex flex-col items-center md:gap-3 mb-6 md:mb-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-service-agreement.png"),
                                        alt: "custom-view",
                                        width: 300,
                                        height: 300,
                                        className: "w-full h-full"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xl md:text-2xl font-semibold mb-2",
                                                children: "Audit trial"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-lg md:text-xl ",
                                                children: "See a detailed record of all actions taken on a document, including who viewed and signed it, for your peace of mind."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "px-0 md:px-8 bg-dark text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " max-w-screen-xl mx-auto px-6 xl:px-8 md:py-32 py-16 md:rounded-2xl flex flex-col md:flex-row md:gap-12 gap-6 justify-between ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex-1 mb-6 md:mb-0 flex flex-col gap-6 relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl md:text-4xl xl:text-5xl font-semibold mb-4",
                                    children: "Trusted E-Signature Platform for Enterprise Operations"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-4 text-white  md:text-xl xl:text-2xl",
                                    children: [
                                        "We understand your unique needs and challenges.",
                                        "Manage all signatures, contracts, and legal docs in one simple platform.",
                                        "Get enterprise-level features without the enterprise price tag."
                                    ].map((check, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex items-start text-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_check/* default */.Z, {
                                                    className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                                }),
                                                check
                                            ]
                                        }, idx))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Buttons/* CLMButtonPrimary */.IS, {
                                        buttonText: "Request a Demo",
                                        buttonUrl: "/clm/request-demo"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full flex-1 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/clm/esignature-enterprise.png"),
                                alt: "Customer discussion",
                                className: "w-full",
                                width: 1000,
                                height: 1000
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "px-0 md:px-8 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " max-w-screen-xl mx-auto px-6 xl:px-8 md:pt-32 pt-16 text-black md:rounded-2xl flex flex-col md:flex-row justify-between ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 ",
                        children: showcaseData2.map((data, idx)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                ref: (el)=>cardRefs.current[idx] = el,
                                className: "scroll-mt-[130px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderShowCase/* ShowCaseCard */.uV, {
                                    title: data.heading,
                                    desc: data.subHeading,
                                    imgSrc: data.imgSrc,
                                    idx: idx,
                                    cat: categories === null || categories === void 0 ? void 0 : categories[idx]
                                })
                            }, idx);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var signature = (Signature);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4599,5499,9774,2888,179], function() { return __webpack_exec__(73512); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);